/**
 * Minimal ABI fragments for the Uniswap V4 StateView contract.
 *
 * Only includes getSlot0 and getLiquidity — the functions needed for
 * pool state reads (sqrtPriceX96, tick, liquidity, fees).
 *
 * Story 5.1 Task 2.2
 */

export const stateViewAbi = [
	{
		type: "function",
		name: "getSlot0",
		inputs: [{ name: "poolId", type: "bytes32", internalType: "PoolId" }],
		outputs: [
			{ name: "sqrtPriceX96", type: "uint160", internalType: "uint160" },
			{ name: "tick", type: "int24", internalType: "int24" },
			{ name: "protocolFee", type: "uint24", internalType: "uint24" },
			{ name: "lpFee", type: "uint24", internalType: "uint24" },
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "getLiquidity",
		inputs: [{ name: "poolId", type: "bytes32", internalType: "PoolId" }],
		outputs: [{ name: "liquidity", type: "uint128", internalType: "uint128" }],
		stateMutability: "view",
	},
] as const;
